<template>
  <div class="installation">

    <header-box :title="title"></header-box>
    <div class="installation__innerwrap">
      <div class="installation__row">
        <div class="installation__blocks">
          <div class="installation__block" v-for="block in oddContentBlocks">
              <h2 class="installation__block-title" v-html="block.title"></h2>
              <div class="installation__block-content" v-html="block.content"></div>
          </div>
        </div>
        <div class="installation__image-wrapper">

          <movie-player v-if="coverVideo" class="installation__video" :movieUrl="coverVideo" :placeholderUrl="coverImage" autoplay="true"></movie-player>
          <img v-if="!coverVideo" class="installation__image" :src="coverImage" />
        </div>
        <div class="installation__blocks installation__blocks--all">
          <div class="installation__block" v-for="block in contentBlocks">
              <h2 class="installation__block-title" v-html="block.title"></h2>
              <div class="installation__block-content" v-html="block.content"></div>
          </div>
        </div>
        <div class="installation__blocks installation__blocks--padded">
          <div class="installation__block" v-for="block in evenContentBlocks">
              <h2 class="installation__block-title" v-html="block.title"></h2>
              <div class="installation__block-content" v-html="block.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrevNextNav from '@/components/PrevNextNav';
import HeaderBox from '@/components/HeaderBox';
import MoviePlayer from '@/components/MoviePlayer';
import Macy from 'macy-watchcss';

export default {
  name: 'installation',
  components: { PrevNextNav, HeaderBox, MoviePlayer },
  computed: {
    ...mapGetters(['page']),
    title() {
      return this.page.title;
    },
    coverType() {
      return this.page.coverType;
    },
    coverImage() {
      return this.page.coverImage;
    },
    coverVideo() {
      return this.page.coverVideo;
    },
    contentBlocks() {
      return this.page.contentBlocks;
    },
    evenContentBlocks() {
      return this.contentBlocks.filter(this.filterEven);
    },
    oddContentBlocks() {
      return this.contentBlocks.filter(this.filterOdd);
    },
  },
  methods: {
    filterEven(block, index) {
      return (index + 1) % 2 === 0;
    },
    filterOdd(block, index) {
      return (index + 1) % 2 === 1;
    },
  },
  mounted() {
    const bgVid = document.querySelector('.installation__video');
    if (bgVid) {
      bgVid.addEventListener('ended', () => {
        bgVid.classList.add('hide');
      });
    }

    Macy({
      container: '.installation__blocks--all',
      trueOrder: true,
      waitForImages: false,
      margin: 20,
      columns: 3,
      watchCSS: true,
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../scss/helpers';

.installation {
  @include page;

  &__innerwrap {
    padding-top: 20px;
  }

  &__row {
    @include not-tablet {
      display: flex;
      align-item: flex-start;
      justify-content: space-between;
      position: relative;
    }
  }

  &__image-wrapper {
    display: block;
    width: 100%;
    margin: 0 auto 20px;
    position: relative;

    @include not-mobile {
      width: 75%;
    }

    @include landscape {
      position: fixed;
      top: 20px;
      left: calc(50% + 10px);
      width: auto;
      right: 20px;
    }

    @include not-tablet {
      width: calc(75% - 60px);
      margin-bottom: 0;
      position: fixed;
      left: calc(12.5% + 30px);
      top: (40px + 91px + 20px);
    }
  }

  &__image {
    width: 100%;
    display: block;
  }

  // &__video {
    // width: 100%;
    // display: block;
    // position: absolute;
    // top: 0;
    // left: 0;
    // right: 0;
    // transition: opacity .5s;

    // &.hide {
    //   opacity: 0;
    //   pointer-events: none;
    // }

    // @include not-tablet {
    //   width: 100%;
    //   margin: 0 auto;
    // }
  // }

  // &__video + &__image {
  //   transition: opacity .5s;
  // }

  // &__video:not(.hide) + &__image {
  //   opacity: 0;
  // }

  &__blocks {
    flex-shrink: 0;
    display: none;
    position: relative;
    z-index: 1;

    &--all {
      display: block;

      @include tablet {
        &::after {
          content: "macy";
          display: none;
        }
      }
    }

    @include landscape {
      width: calc(50% - 10px);

      &::after {
        content: none;
      }
    }

    @include not-tablet {
      width: calc(25% - 10px);
      display: block;
      margin-bottom: 20px;

      &--all {
        display: none;
      }

      &--padded {
        padding-top: 100px;
      }
    }

  }

  &__block {
    display: block;
    box-sizing: border-box;
    margin-bottom: 20px;
    padding: 40px 30px 30px;
    background: $c_white;

    @include tablet {
      width: 33.33%;
    }

    @include landscape {
      width: auto;
    }

    @include not-tablet {
      padding: 50px 40px 40px;
    }
  }

  &__block-title {
    @include font-block-title;
  }

  &__block-content {
    @include font-block-content;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/templates/Installation.vue